var API_DOMAIN = "https://zenpos.zentexus.com/api";

export default API_DOMAIN;
